import { render, staticRenderFns } from "./DetailFoodModal.vue?vue&type=template&id=45d8c7eb"
import script from "./DetailFoodModal.vue?vue&type=script&lang=js"
export * from "./DetailFoodModal.vue?vue&type=script&lang=js"
import style0 from "./DetailFoodModal.vue?vue&type=style&index=0&id=45d8c7eb&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Volumes/Untitled/project/050/050admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('45d8c7eb')) {
      api.createRecord('45d8c7eb', component.options)
    } else {
      api.reload('45d8c7eb', component.options)
    }
    module.hot.accept("./DetailFoodModal.vue?vue&type=template&id=45d8c7eb", function () {
      api.rerender('45d8c7eb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/order/food/components/DetailFoodModal.vue"
export default component.exports